<template>
<div>
    <div id="solar-hotwater" class="wrapper">
        <!-- 内容は以下に記述して下さい。 -->
        <!-- 液体集熱式太陽熱利用設備 -->
        <app-error-list />
        <app-section>
            <h3 slot="h3">
                <parts-arrow category="太陽熱利用">1</parts-arrow>
                <span><parts-arrow class="line">1</parts-arrow>で液体集熱式太陽熱利用設備の設置の有無等を入力して下さい。</span>
            </h3>
            <app-box
                :available="true"
                label="液体集熱式太陽熱利用設備"
                class="flex_column"
                name="sw_saiyou"
                @click="guideTransition"
            >
                <app-radio
                    v-for="value in ['2','1']"
                    v-model="sw_saiyou"
                    :value="value"
                    unit=""
                    :key="'sw_saiyou' + value"
                >
                    {{master.sw_saiyou[value]}}
                </app-radio>
                <information-box title="液体集熱式太陽熱利用設備を設置する場合">
                    <ul>
                        <li>年間の日射地域区分の指定が必要です。</li>
                        <li>
                            以下については、<a href="https://house.lowenergy.jp/dictionary/solar#sw_saiyou" target="guide" class="target_blank">こちら</a>で確認できます。
                            <ul>
                                <li>液体集熱式太陽熱利用設備との組み合わせを評価できない設備機器</li>
                                <li>液体集熱式太陽熱利用設備と同時に設置する場合に、入力方法に注意が必要な給湯設備</li>
                            </ul>
                        </li>
                    </ul>
                </information-box>
            </app-box>
            <app-box
                label="設備の種類"
                name="sw_sr"
                @click="guideTransition"
                :available="true"
                v-if="sw_saiyou == '1'"
            >
                <app-radio
                    v-for="(name, value) in master.sw_sr"
                    v-model="sw_sr"
                    :value="value"
                    unit=""
                    :key="'sw_sr' + value"
                >
                    {{name}}
                </app-radio>
            </app-box>
        </app-section>
        
        <div v-if="sw_saiyou == '1'">
            <!-- 太陽熱温水器 -->
            <app-section v-if="sw_sr == '1'">
                <h3 slot="h3">
                    <parts-arrow category="太陽熱利用">2</parts-arrow>
                    <span>「太陽熱温水器」を選択した場合、太陽熱利用設備の評価方法を入力して下さい。</span>
                </h3>
                <app-box
                    :available="true"
                    label="面積の入力方法"
                    class="flex_column"
                    name="sw_sr1_menseki"
                    @click="guideTransition"
                >
                    <app-radio
                        v-for="(name, value) in master.sw_sr1_menseki"
                        v-model="sw_sr1_menseki"
                        :value="value"
                        unit=""
                        :key="'sw_sr1_menseki' + value"
                    >
                        {{name}}
                    </app-radio>
                </app-box>
                <app-box
                    :available="true"
                    v-if="sw_sr1_menseki == '1'"
                    label="集熱部総面積、または集熱貯湯部総面積"
                    class="flex_column"
                >
                    <app-text 
                        v-model="sw_sr1_menseki_all"
                        label=""
                        unit="m2"
                        subscript="(小数点以下1桁)"
                        :step="0.1"
                        class="number"
                    />
                </app-box>
                <app-box
                    :available="true"
                    v-if="sw_sr1_menseki == '2'"
                    label="有効集熱面積"
                    class="flex_column"
                >
                    <app-text
                        v-model="sw_sr1_menseki_eff"
                        label=""
                        unit="m2"
                        subscript="(小数点以下1桁)"
                        :step="0.1"
                        class="number"
                    />
                </app-box>
                <app-box
                    :available="true"
                    label="集熱部の設置方位角"
                    class="flex_column"
                    name="sw_sr1_angle"
                    @click="guideTransition"
                >
                    <app-radio
                        v-for="(name, value) in master.sw_sr1_angle"
                        v-model="sw_sr1_angle"
                        :value="value"
                        unit=""
                        :key="'sw_sr1_angle' + value"
                    >
                        {{name}}
                    </app-radio>
                </app-box>
                <app-box
                    :available="true"
                    label="集熱部の設置傾斜角"
                    class="flex_column"
                    name="sw_sr1_slope"
                    @click="guideTransition"
                >
                    <app-radio
                        v-for="(name, value) in master.sw_sr1_slope"
                        v-model="sw_sr1_slope"
                        :value="value"
                        unit=""
                        :key="'sw_sr1_slope' + value"
                    >
                        {{name}}
                    </app-radio>
                </app-box>
            </app-section>
            

            <!-- ソーラーシステム -->
            <app-section v-if="sw_sr == '2'">
                <h3 slot="h3">
                    <parts-arrow category="太陽熱利用">2</parts-arrow>
                    <span><parts-arrow class="line">1</parts-arrow>で「ソーラーシステム」を選択した場合、太陽熱利用設備の評価方法を入力して下さい。</span>
                </h3>
                <app-box
                    :available="true"
                    label="面積の入力方法"
                    class="flex_column"
                    name="sw_sr2_menseki"
                    @click="guideTransition"
                >
                    <app-radio
                        v-for="(name, value) in master.sw_sr2_menseki"
                        v-model="sw_sr2_menseki"
                        :value="value"
                        unit=""
                        :key="'sw_sr2_menseki' + value"
                    >
                        {{name}}
                    </app-radio>
                </app-box>
                <app-box
                    :available="true"
                    v-if="sw_sr2_menseki == '1'"
                    label="集熱器総面積"
                    class="flex_column"
                >
                    <app-text
                        v-model="sw_sr2_menseki_all"
                        label=""
                        unit="m2"
                        subscript="(小数点以下1桁)"
                        :step="0.1"
                        class="number"
                    />
                </app-box>
                <app-box
                    :available="true"
                    v-if="sw_sr2_menseki == '2'"
                    label="有効集熱面積"
                    class="flex_column"
                >
                    <app-text
                        v-model="sw_sr2_menseki_eff"
                        label=""
                        unit="m2"
                        subscript="(小数点以下1桁)"
                        :step="0.1"
                        class="number"
                    />
                </app-box>
                <app-box
                    :available="true"
                    label="集熱部の設置方位角"
                    class="flex_column"
                    name="sw_sr2_angle"
                    @click="guideTransition"
                >
                    <app-radio
                        v-for="(name, value) in master.sw_sr1_angle"
                        v-model="sw_sr2_angle"
                        :value="value"
                        unit=""
                        :key="'sw_sr2_angle' + value"
                    >
                        {{name}}
                    </app-radio>
                </app-box>
                <app-box
                    :available="true"
                    label="集熱部の設置傾斜角"
                    class="flex_column"
                    name="sw_sr2_slope"
                    @click="guideTransition"
                >
                    <app-radio
                        v-for="(name, value) in master.sw_sr1_slope"
                        v-model="sw_sr2_slope"
                        :value="value"
                        unit=""
                        :key="'sw_sr1_slope' + value"
                    >
                        {{name}}
                    </app-radio>
                </app-box>
                <app-box
                    :available="true"
                    label="貯湯タンクの容量"
                    class="flex_column"
                    name="sw_sr2_tankyouryo"
                    @click="guideTransition"
                >
                    <app-text
                        v-model="sw_sr2_tankyouryo"
                        label=""
                        unit="L"
                        subscript="(整数)"
                        :step="1"
                        class="number"
                    />
                </app-box>
            </app-section>
        </div>
        


        <!-- 空気集熱式太陽熱利用設備 -->
        <app-section>
            <h3 slot="h3">
                <parts-arrow category="太陽熱利用">3</parts-arrow>
                <span>空気集熱式太陽熱利用設備の設置の有無等を入力して下さい。</span>
            </h3>
            <app-box
                :available="true"
                label="空気集熱式太陽熱利用設備"
                class="flex_column"
                name="om_saiyou"
                @click="guideTransition"
            >
                <app-radio
                    v-for="value in ['2','1']"
                    v-model="om_saiyou"
                    :value="value"
                    unit=""
                    :key="'om_saiyou' + value"
                >
                    {{master.om_saiyou[value]}}
                </app-radio>
                <information-box title="空気集熱式太陽熱利用設備を設置する場合">
                    <ul>
                        <li>年間の日射地域区分の指定が必要です。</li>
                        <li>以下については、<a href="https://house.lowenergy.jp/dictionary/solar#om_saiyou" target="guide" class="target_blank">こちら</a>で確認できます。
                            <ul>
                                <li>空気集熱式太陽熱利用設備との組み合わせを評価できない設備機器・方式</li>
                                <li>空気集熱式太陽熱利用設備と同時に設置する場合に、入力方法に注意が必要な給湯設備</li>
                            </ul>
                        </li>
                    </ul>
                </information-box>
            </app-box>
            
            <app-box
                v-if="om_saiyou == '1'"
                :available="true"
                label="集熱器群の数"
                class="flex_column"
                name="om_panelsuu"
                @click="guideTransition"
            >
                <app-radio
                    v-for="count in 4"
                    v-model="om_panelsuu"
                    :value="count.toString()"
                    label="1"
                    unit=""
                    :key="count"
                >
                    {{count}}面
                </app-radio>
            </app-box>
            <app-box
                v-if="om_saiyou == '1'"
                :available="true"
                label="集熱部の方位角"
                class="flex_column"
                name="om_panel_houi"
                @click="guideTransition"
            >
                <app-radio
                    v-for="(name, value) in master.sw_sr1_angle"
                    v-model="om_panel_houi"
                    :value="value"
                    unit=""
                    :key="'om_panel_houi' + value"
                >
                    {{name}}
                </app-radio>
            </app-box>
            <app-box
                v-if="om_saiyou == '1'"
                :available="true"
                label="空気搬送ファンの自立運転用太陽光発電装置"
                class="flex_column"
                name="om_fan_jirituunten"
                @click="guideTransition"
            >
                <app-radio
                    v-for="value in ['2','1']"
                    v-model="om_fan_jirituunten"
                    :value="value"
                    unit=""
                    :key="'om_fan_jirituunten' + value"
                >
                    {{master.om_fan_jirituunten[value]}}
                </app-radio>
            </app-box>
            <app-box
                v-if="om_saiyou == '1'"
                :available="true"
                label="空気搬送ファンの種別"
                class="flex_column"
                name="om_fan_type"
                @click="guideTransition"
            >
                <app-radio
                    v-for="value in ['2','1']"
                    v-model="om_fan_type"
                    :value="value"
                    unit=""
                    :key="'om_fan_type' + value"
                >
                    {{master.om_fan_type[value]}}
                </app-radio>
            </app-box>
            <app-box
                v-if="om_saiyou == '1'"
                :available="true"
                label="機外静圧をゼロとした時の空気搬送ファンの風量"
                class="flex_column"
                name="om_fan_test"
                @click="guideTransition"
            >
                <app-text 
                    v-model="om_fan_test"
                    label=""
                    unit="m3/h"
                    subscript="(小数点以下1桁)"
                    class="number"
                    :step="0.1"
                />
            </app-box>
            <app-box
                v-if="om_saiyou == '1'"
                :available="true"
                label="集熱した熱の給湯への利用"
                class="flex_column"
            >
                <app-radio
                    v-for="value in ['2','1']"
                    v-model="om_hw_saiyou"
                    :value="value"
                    unit=""
                    :key="'om_hw_saiyou' + value"
                >
                    {{master.om_hw_saiyou[value]}}
                </app-radio>
            </app-box>
            <app-box
                v-if="om_saiyou == '1' && om_hw_saiyou == '1'"
                :available="true"
                label="循環ポンプの自立運転用太陽光発電装置"
                class="flex_column"
                name="om_pump_jirituunten"
                @click="guideTransition"
            >
                <app-radio
                    v-for="value in ['2','1']"
                    v-model="om_pump_jirituunten"
                    :value="value"
                    unit=""
                    :key="'om_pump_jirituunten' + value"
                >
                    {{master.om_fan_jirituunten[value]}}
                </app-radio>
            </app-box>
            <app-box
                 v-if="om_saiyou == '1' && om_hw_saiyou == '1'"
                :available="true"
                label="給湯部のタンク容量"
                class="flex_column"
                name="om_tankyouryo"
                @click="guideTransition"
            >
                <app-text
                    v-model="om_tankyouryo"
                    label=""
                    unit="L"
                    subscript="(整数)"
                    class="number"
                />
            </app-box>
            <app-box
                v-if="om_saiyou == '1'"
                :available="true"
                label="集熱後の空気を供給する空間"
                class="flex_column"
            >
                <app-radio
                    v-for="(name, value) in master.om_supply_target"
                    v-model="om_supply_target"
                    :value="value"
                    unit=""
                    :key="'om_supply_target' + value"
                >
                    {{name}}
                </app-radio>
            </app-box>
            <app-box
                v-if="om_saiyou == '1' && om_supply_target == '1'"
                :available="true"
                label="集熱後の空気を供給する床下の面積の割合"
                class="flex_column"
                name="om_ufv_area_rate"
                @click="guideTransition"
            >
                <app-text
                    v-model="om_ufv_area_rate"
                    label=""
                    unit="%"
                    subscript="(整数)"
                    class="number"
                />
            </app-box>
            <app-box
                v-if="om_saiyou == '1' && om_supply_target == '1'"
                :available="true"
                label="床下空間の断熱"
                class="flex_column"
                name="om_ufv_dannetsu"
                @click="guideTransition"
            >
                <app-radio
                    v-for="(name, value) in master.ip_ufv_dannetsu"
                    v-model="om_ufv_dannetsu"
                    :value="value"
                    unit=""
                    :key="'om_ufv_dannetsu' + value"
                >
                    {{name}}
                </app-radio>
             </app-box>
        </app-section>

        <!-- 集熱器群その1 -->
        <app-section v-if="om_saiyou == '1' && om_panelsuu >= 1">
            <h3 slot="h3">
                <parts-arrow category="太陽熱利用">4</parts-arrow>
                <span>集熱器群その1の評価方法を入力して下さい。</span>
            </h3>
            <app-box
                :available="true"
                label="集熱器群の面積"
                class="flex_column"
                name="om_panel_menseki"
                @click="guideTransition"
            >
                <app-text
                    v-model="om_panel1_menseki"
                    label=""
                    unit="m2"
                    subscript="(小数点以下1桁)"
                    :step="0.1"
                    class="number"
                />
            </app-box>
            <app-box
                :available="true"
                label="集熱器群の傾斜角"
                class="flex_column"
                name="om_panel_keisha"
                @click="guideTransition"
            >
                <app-radio
                    v-for="(name, value) in master.sw_sr1_slope"
                    v-model="om_panel1_keisha"
                    :value="value"
                    unit=""
                    :key="'om_panel1_keisha' + value"
                >
                    {{name}}
                </app-radio>
            </app-box>
            <app-box
                :available="true"
                label="集熱器群の仕様の入力"
                class="flex_column"
                name="om_panel_input"
                @click="guideTransition"
            >
                <app-radio
                    v-for="value in ['2','1']"
                    v-model="om_panel1_input"
                    :value="value"
                    unit=""
                    :key="'om_panel1_input' + value"
                >
                    {{master.om_panel_input[value]}}
                </app-radio>
            </app-box>
            <div v-if="om_panel1_input == '1'">
                <app-box
                    :available="true"
                    label="集熱器の集熱効率特性線図一次近似式の切片"
                    class="flex_column"
                    name="om_panel_d0"
                    @click="guideTransition"
                >
                    <app-text
                        v-model="om_panel1_d0"
                        label=""
                        unit=""
                        subscript="(小数点以下1桁)"
                        :step="0.1"
                        class="number"
                    />
                </app-box>
                <app-box
                    :available="true"
                    label="集熱器の集熱効率特性線図一次近似式の傾き"
                    class="flex_column"
                    name="om_panel_d1"
                    @click="guideTransition"
                >
                    <app-text
                        v-model="om_panel1_d1"
                        label=""
                        unit="W/m2K"
                        subscript="(小数点以下1桁)"
                        :step="0.1"
                        class="number"
                    />
                </app-box>
                <app-box
                    :available="true"
                    label="集熱器の集熱性能試験時における単位面積当たりの空気の質量流量"
                    class="flex_column"
                    name="om_panel_mfan"
                    @click="guideTransition"
                >
                    <app-text
                        v-model="om_panel1_mfan"
                        label=""
                        unit="kg/sm2"
                        subscript="(小数点以下4桁)"
                        :step="0.0001"
                        class="number"
                    />
                </app-box>
            </div>
        
        </app-section>
        
        
        <!-- 集熱器群その2 -->
        <app-section v-if="om_saiyou == '1' && om_panelsuu >= 2">
            <h3 slot="h3">
                <parts-arrow category="太陽熱利用">5</parts-arrow>
                <span>集熱器群その2の評価方法を入力して下さい。</span>
            </h3>
            <app-box
                :available="true"
                label="集熱器群の面積"
                class="flex_column"
                name="om_panel_menseki"
                @click="guideTransition"
            >
                <app-text
                    v-model="om_panel2_menseki"
                    label=""
                    unit="m2"
                    subscript="(小数点以下1桁)"
                    :step="0.1"
                    class="number"
                />
            </app-box>
            <app-box
                :available="true"
                label="集熱器群の傾斜角"
                class="flex_column"
                name="om_panel_keisha"
                @click="guideTransition"
            >
                <app-radio
                    v-for="(name, value) in master.sw_sr1_slope"
                    v-model="om_panel2_keisha"
                    :value="value"
                    unit=""
                    :key="'om_panel2_keisha' + value"
                >
                    {{name}}
                </app-radio>
            </app-box>
            <app-box
                :available="true"
                label="集熱器群の仕様の入力"
                class="flex_column"
                name="om_panel_input"
                @click="guideTransition"
            >
                <app-radio
                    v-for="value in ['2','1']"
                    v-model="om_panel2_input"
                    :value="value"
                    unit=""
                    :key="'om_panel2_input' + value"
                >
                    {{master.om_panel_input[value]}}
                </app-radio>
            </app-box>
            <div v-if="om_panel2_input == '1'">
                <app-box
                    :available="true"
                    label="集熱器の集熱効率特性線図一次近似式の切片"
                    class="flex_column"
                    name="om_panel_d0"
                    @click="guideTransition"
                >
                    <app-text
                        v-model="om_panel2_d0"
                        label=""
                        unit=""
                        subscript="(小数点以下1桁)"
                        :step="0.1"
                        class="number"
                    />
                </app-box>
                <app-box
                    :available="true"
                    label="集熱器の集熱効率特性線図一次近似式の傾き"
                    class="flex_column"
                    name="om_panel_d1"
                    @click="guideTransition"
                >
                    <app-text
                        v-model="om_panel2_d1"
                        label=""
                        unit="W/m2K"
                        subscript="(小数点以下1桁)"
                        :step="0.1"
                        class="number"
                    />
                </app-box>
                <app-box
                    :available="true"
                    label="集熱器の集熱性能試験時における単位面積当たりの空気の質量流量"
                    class="flex_column"
                    name="om_panel_mfan"
                    @click="guideTransition"
                >
                    <app-text
                        v-model="om_panel2_mfan"
                        label=""
                        unit="kg/sm2"
                        subscript="(小数点以下4桁)"
                        :step="0.0001"
                        class="number"
                    />
                </app-box>
            </div>
        </app-section>
        
        
        <!-- 集熱器群その3 -->
        <app-section v-if="om_saiyou == '1' && om_panelsuu >= 3">
            <h3 slot="h3">
                <parts-arrow category="太陽熱利用">6</parts-arrow>
                <span>集熱器群その3の評価方法を入力して下さい。</span>
            </h3>
            <app-box
                :available="true"
                label="集熱器群の面積"
                class="flex_column"
                name="om_panel_menseki"
                @click="guideTransition"
            >
                <app-text
                    v-model="om_panel3_menseki"
                    label=""
                    unit="m2"
                    subscript="(小数点以下1桁)"
                    :step="0.1"
                    class="number"
                />
            </app-box>
            <app-box
                :available="true"
                label="集熱器群の傾斜角"
                class="flex_column"
                name="om_panel_keisha"
                @click="guideTransition"
            >
                <app-radio
                    v-for="(name, value) in master.sw_sr1_slope"
                    v-model="om_panel3_keisha"
                    :value="value"
                    unit=""
                    :key="'om_panel3_keisha' + value"
                >
                    {{name}}
                </app-radio>
            </app-box>
            <app-box
                :available="true"
                label="集熱器群の仕様の入力"
                class="flex_column"
                name="om_panel_input"
                @click="guideTransition"
            >
                <app-radio
                    v-for="value in ['2','1']"
                    v-model="om_panel3_input"
                    :value="value"
                    unit=""
                    :key="'om_panel3_input' + value"
                >
                    {{master.om_panel_input[value]}}
                </app-radio>
            </app-box>
            <div v-if="om_panel3_input == '1'">
                <app-box
                    :available="true"
                    label="集熱器の集熱効率特性線図一次近似式の切片"
                    class="flex_column"
                    name="om_panel_d0"
                    @click="guideTransition"
                >
                    <app-text
                        v-model="om_panel3_d0"
                        label=""
                        unit=""
                        subscript="(小数点以下1桁)"
                        :step="0.1"
                        class="number"
                    />
                </app-box>
                <app-box
                    :available="true"
                    label="集熱器の集熱効率特性線図一次近似式の傾き"
                    class="flex_column"
                    name="om_panel_d1"
                    @click="guideTransition"
                >
                    <app-text
                        v-model="om_panel3_d1"
                        label=""
                        unit="W/m2K"
                        subscript="(小数点以下1桁)"
                        :step="0.1"
                        class="number"
                    />
                </app-box>
                <app-box
                    :available="true"
                    label="集熱器の集熱性能試験時における単位面積当たりの空気の質量流量"
                    class="flex_column"
                    name="om_panel_mfan"
                    @click="guideTransition"
                >
                    <app-text
                        v-model="om_panel3_mfan"
                        label=""
                        unit="kg/sm2"
                        subscript="(小数点以下4桁)"
                        :step="0.0001"
                        class="number"
                    />
                </app-box>
            </div>
        </app-section>
        
        
        <!-- 集熱器群その4 -->
        <app-section v-if="om_saiyou == '1' && om_panelsuu >= 4">
            <h3 slot="h3">
                <parts-arrow category="太陽熱利用">7</parts-arrow>
                <span>集熱器群その4の評価方法を入力して下さい。</span>
            </h3>
            <app-box
                :available="true"
                label="集熱器群の面積"
                class="flex_column"
                name="om_panel_menseki"
                @click="guideTransition"
            >
                <app-text
                    v-model="om_panel4_menseki"
                    label=""
                    unit="m2"
                    subscript="(小数点以下1桁)"
                    :step="0.1"
                    class="number"
                />
            </app-box>
            <app-box
                :available="true"
                label="集熱器群の傾斜角"
                class="flex_column"
                name="om_panel_keisha"
                @click="guideTransition"
            >
                <app-radio
                    v-for="(name, value) in master.sw_sr1_slope"
                    v-model="om_panel4_keisha"
                    :value="value"
                    unit=""
                    :key="'om_panel4_keisha' + value"
                >
                    {{name}}
                </app-radio>
            </app-box>
            <app-box
                :available="true"
                label="集熱器群の仕様の入力"
                class="flex_column"
                name="om_panel_input"
                @click="guideTransition"
            >
                <app-radio
                    v-for="value in ['2','1']"
                    v-model="om_panel4_input"
                    :value="value"
                    unit=""
                    :key="'om_panel4_input' + value"
                >
                    {{master.om_panel_input[value]}}
                </app-radio>
            </app-box>
            <div v-if="om_panel4_input == '1'">
                <app-box
                    :available="true"
                    label="集熱器の集熱効率特性線図一次近似式の切片"
                    class="flex_column"
                    name="om_panel_d0"
                    @click="guideTransition"
                >
                    <app-text
                        v-model="om_panel4_d0"
                        label=""
                        unit=""
                        subscript="(小数点以下1桁)"
                        :step="0.1"
                        class="number"
                    />
                </app-box>
                <app-box
                    :available="true"
                    label="集熱器の集熱効率特性線図一次近似式の傾き"
                    class="flex_column"
                    name="om_panel_d1"
                    @click="guideTransition"
                >
                    <app-text
                        v-model="om_panel4_d1"
                        label=""
                        unit="W/m2K"
                        subscript="(小数点以下1桁)"
                        :step="0.1"
                        class="number"
                    />
                </app-box>
                <app-box
                    :available="true"
                    label="集熱器の集熱性能試験時における単位面積当たりの空気の質量流量"
                    class="flex_column"
                    name="om_panel_mfan"
                    @click="guideTransition"
                >
                    <app-text
                        v-model="om_panel4_mfan"
                        label=""
                        unit="kg/sm2"
                        subscript="(小数点以下4桁)"
                        :step="0.0001"
                        class="number"
                    />
                </app-box>
            </div>
        </app-section>
        
        <!-- 内容ここまで -->
    </div>
</div>
</template>

<script>
/**
 * 詳細版太陽熱情報入力画面
 * 
 * [算出プロパティ]
 * 詳細版インタフェイス定義の同名項目に準ずる
 * 
 * [イベント処理]
 * インタフェイス定義済み項目の更新時 ... Storeの該当するキーのデータも更新される
 */
import help from "@/mixins/help"
import master from "@/mixins/master"
import { mapGetters, mapActions } from 'vuex'
import { mapComputedProperties } from '@/util'

export default {
    name:"PageManualSolar",
    computed: {
        ...mapGetters('data', {
            data:'getData',
        }),
        ...mapComputedProperties([
            'sw_saiyou',
            'sw_sr',
            'sw_sr1_menseki',
            'sw_sr1_menseki_all',
            'sw_sr1_menseki_eff',
            'sw_sr1_angle',
            'sw_sr1_slope',
            'sw_sr2_menseki',
            'sw_sr2_menseki_all',
            'sw_sr2_menseki_eff',
            'sw_sr2_angle',
            'sw_sr2_slope',
            'sw_sr2_tankyouryo',
            'om_saiyou',
            'om_panelsuu',
            'om_panel_houi',
            'om_fan_jirituunten',
            'om_fan_type',
            'om_fan_test',
            'om_hw_saiyou',
            'om_pump_jirituunten',
            'om_tankyouryo',
            'om_supply_target',
            'om_ufv_area_rate',
            'om_ufv_dannetsu',
            'om_panel1_menseki',
            'om_panel1_keisha',
            'om_panel1_input',
            'om_panel1_d0',
            'om_panel1_d1',
            'om_panel1_mfan',
            'om_panel2_menseki',
            'om_panel2_keisha',
            'om_panel2_input',
            'om_panel2_d0',
            'om_panel2_d1',
            'om_panel2_mfan',
            'om_panel3_menseki',
            'om_panel3_keisha',
            'om_panel3_input',
            'om_panel3_d0',
            'om_panel3_d1',
            'om_panel3_mfan',
            'om_panel4_menseki',
            'om_panel4_keisha',
            'om_panel4_input',
            'om_panel4_d0',
            'om_panel4_d1',
            'om_panel4_mfan'
        ])
    },
    mixins:[help, master],
    methods:{
        ...mapActions('data', ['update']),
    }
}
</script>

<style scoped>
</style>

